import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { history } from '../../routes';
import config from '../../config';

import logo from '../../assets/img/logo.png';
import medal from '../../assets/img/medal.png';
import Button from '../commons/Button';
import ButtonIcon from '../commons/ButtonIcon';
import MenuItem from '../commons/MenuItem';
import UserProfileImage from '../commons/UserProfileImage';
import IconPointsCircle from '../customs/IconPointsCircle';
import IconCoinsCircle from '../customs/IconCoinsCircle';
import { capitalizePhrase, capitalize } from '../../libraries/utils';
import userActions from '../../context/users/actions';
import prizesActions from '../../context/benefits/actions';
import settingsActions from '../../context/settings/actions'

import tooltip_point from "../../assets/img/puntos-shary-circle.png";
import tooltip_impact from "../../assets/img/puntos-impacto-circle.png";

import { notify } from '../../libraries/notifications';

export default function Sidebar({ header }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [collapseShow, setCollapseShow] = React.useState("close");
  const user = useSelector(state => state.users.auth.user);
  const rewards = useSelector(state => state.users.auth.user.rewards)
  const ranking = useSelector(state => state.users.list.ranking);
  const prizes = useSelector(state => state.benefits.list.items)
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch();
  const [userRanking, setUserRanking] = useState("N/A");
  const [areNewPrizes, setAreNewPrizes] = useState(false)
  const [mainMenu, setMainMenu] = useState([]);
  const [showingBenefits, setSowingBenefits] = useState(false);
  const [showingPrizes, setSowingPrizes] = useState(false);
  const onGetSettings = async params => dispatch(settingsActions.getAll(params))

  const notifications = useSelector(state => state.notifications.list)
  const unReadedNotifications = notifications.items.filter(n => n.readed === 0 && ["notification"].includes(n.type)).length
  const unReadedMessages = notifications.items.filter(n => n.readed === 0 && ["message", "question"].includes(n.type)).length

  const getRanking = () => {
    // await this.props.onGetUsersRanking({ user_type: config.USER_TYPE.REGULAR, unique_id: this.props.auth.user.unique_id });
    if(!ranking.length){
      dispatch(userActions.getRanking({ user_type: config.USER_TYPE.REGULAR, unique_id: user.unique_id }));
    }
  }

  const getActions = () => {
    if(!prizes.length) {
      dispatch(prizesActions.getAll({enabled: 1, type: ["prize"], owner: user.unique_id}))
    }
  }

  const getRewards = () => {
    dispatch(userActions.getRewards({id: user.id, isPublicProfile: false}))
  }

  const getSettings = async () => {
    if(settings.list.items.length || settings.list.loading) return
    const params = {
      type: "sharyco_settings",
      owner: user.unique_id,
    };
    await onGetSettings(params)
    if (settings.error) {
      console.log(settings.error.message);
    }
  }

  const filterSidebar = () => {
    if (!settings.list.items.length) return;
    let menu = config.SIDEBAR.MENU.MAIN;
    let showingBenefits = true;
    let showingPrizes = true
    settings.list.items.forEach((item) => {
      if (
        item.type === "sharyco_settings" &&
        (!item.value || item.value === "false")
      ) {
        switch (item.code) {
          case "show_actions":
            menu = menu.filter(
              (section) => section.route !== config.ROUTES.HOME_OPTIONS.ACTIONS
            );
            break;
          case "show_offers":
            menu = menu.filter(
              (section) =>
                section.route !== config.ROUTES.USER.INVENTORY &&
                section.route !== config.ROUTES.USER.LOANS &&
                section.route !== config.ROUTES.USER.RETURNS
            );
            break;
          case "show_benefits":
            showingBenefits = false;
            break;
          case "show_prizes":
            showingPrizes = false;
            break;
          default:
            break;
        }
      }
    });
    setMainMenu(menu);
    setSowingBenefits(showingBenefits);
    setSowingPrizes(showingPrizes)
  };

  useEffect(() => {
    getRanking()
    getActions()
    getRewards()
    getSettings()
  }, [])

  useEffect(()=>{
    if(ranking?.error){
      notify('Error obteniendo el ranking')
    } else {
      let user_ranking = "N/A"
      if(ranking){
        ranking.forEach((r, index) => {
          if(r.id === user.id && r?.points !== "0") {
            user_ranking = index+1;
          }
        })
      }
      setUserRanking(user_ranking)
    }
  }, [ranking,user])

  useEffect(() => {
    if(prizes?.error){
      notify('Error cargando premios')
    } else {
      const lastSeenPrize = localStorage.getItem("lastSeenPrize")
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7)
      const areNew = prizes.some(p => (new Date(p.created_at) > new Date(oneWeekAgo)) && (new Date(p.created_at) > new Date(lastSeenPrize)))
      setAreNewPrizes(areNew)
    }
  }, [prizes])

  useEffect(() => {
    filterSidebar()
  }, [settings])

  return (
    <>
    <nav className={"z-50 py-3 px-3 flex items-center h-16 " + (header && header.className ? header.className : "bg-base-100")}>
      <div className="flex-no-wrap flex gap-3 items-center w-full">
        <div className=" relative">
          {/*<ButtonIcon
            buttonClassName="btn-ghost btn-sm"
            className="w-6 h-6"
            onClick={() => setCollapseShow("open")}
            icon="menu"
          />*/}
          <div className={"rounded-full bg-primary bg-opacity-30 overflow-hidden flex items-center text-center m-auto w-12 h-12 border-2 border-secondary"}
            onClick={() => setCollapseShow("open")}>
            {user.profile_image ? (<img className="w-full h-full object-cover" src={user.profile_image} alt="profile_img" />)
            : (<span className="m-auto text-white text-2xl">{user.username}</span>)}
          </div>
            {!!unReadedNotifications && <span className="absolute bottom-0.5 right-0.5 w-3 h-3 z-20 bg-error rounded-full" />}
        </div>
        { header && header.title ? (
            <h4 className="mb-1 mr-auto">{header.title}</h4>
          ) : header && header.logo && (
            <div className="mr-auto">
              <img src={logo} alt="" width="100px" />
            </div>
          )
        }
        {header && header.logo && (
        <div className="">
           {rewards &&
            <div className="display flex text-center gap-3 justify-center">
              <div className='bg-secondary bg-opacity-10 rounded-full w-10 h-10 grid text-primary'>
                <IconPointsCircle iconClassName='w-6' className='flex flex-col items-center justify-center text-xs font-semibold' points={rewards?.total?.points}/>
              </div>
              <div className='bg-secondary bg-opacity-10 rounded-full w-10 h-10 grid text-primary'>
                <IconCoinsCircle className='flex justify-self-end flex-col items-center justify-center text-xs font-semibold' coins={rewards?.total?.coins}/>
              </div>
            </div>
            }
          </div>)}
          { header && header.right && (
            <ButtonIcon
              buttonClassName={"btn-ghost btn-circle btn-sm justify-self-end " + (header.right.buttonClassName ? header.right.buttonClassName : "")}
              className={header.right.className ? header.right.className : "h-4 w-4"}
              onClick={header.right.action}
              icon={header.right.icon}
            />
          )}


      </div>

      <div
        className={
          "text-primary-content z-50 transform top-0 left-0 bottom-0 w-72 bg-primary shadow-lg fixed h-full overflow-auto ease-in-out transition-all duration-300 flex justify-between flex-col " + (collapseShow === "close" ? "-translate-x-full" : "translate-x-0")
        }
      >
        <div className="md:min-w-full block pb-4">
          <ButtonIcon
            buttonClassName="btn-ghost btn-sm absolute right-1 top-2 z-20"
            className="w-8 h-8"
            onClick={() => setCollapseShow("close")}
            icon="close"
          />


          <div className="pb-14 relative overflow-hidden">
            <div className='bg-base-content absolute top-0 w-full left-0 h-full z-10 bg-opacity-60'></div>
            <img src={user?.profile_image} className='w-full h-full absolute top-0 mix-blend-soft-light blur-sm left-0 z-0 object-cover' alt=""/>
            <div className='flex flex-row px-4 text-center pt-10 z-10 relative'>
              <div className='flex items-end justify-center'>
                
                <div class="dropdown dropdown-hover dropdown-top dropdown-start">
                  <div className="rounded-full text-white w-12 h-12 grid">
                    <IconCoinsCircle  className="sidebar--points" coins={rewards?.total?.coins}/>
                    <div tabindex="0" class="dropdown-content z-[2] card card-compact p-2 w-[16rem] mt-2 shadow-xl bg-base-200 bg-transparent-90 text-neutral-content mb-2">
                        <h3 class="card-title text-base-content text-sm mb-4">Puntos Shary</h3>
                        <div class="flex items-start ">
                          <div class="w-8 h-8  flex-shrink-0 absolute top-1 right-1">
                            <img src={tooltip_point} alt="puntos" />
                          </div>
                          <div class="text-xs text-left space-y-2 text-base-content">
                            <p className='text-xs'>Se suman al hacer acciones o compartir. Se descuentan al pedir productos o favores.</p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div> 
              </div>

              <div className="flex-1">
                <UserProfileImage data={user} />
                {/*<div className="flex justify-center gap-3 mx-auto">
                  <div className="badge bg-base-100 bg-opacity-20 badge-sm border-none">{user.ancestors?.company?.name}</div>
                </div>*/}
                <h3>{capitalizePhrase(user?.name)}</h3>
                {typeof user?.rewards?.level === 'number' && <p>Nivel {rewards?.level}</p>}
                <Button
                  className="btn-ghost text-secondary btn-xs px-4 mx-auto "
                  title={t("Profile")}
                  onClick={() => history.push(config.ROUTES.USER.PROFILE)}
                />
              </div>
              <div className='flex items-end justify-center'>

                <div class="dropdown dropdown-hover dropdown-top dropdown-end">
                  <div className="rounded-full text-white w-12 h-12 grid">
                    <IconPointsCircle className="sidebar--points"  points={rewards?.total?.points} iconClassName="w-5" />
                    <div tabindex="0" class="dropdown-content z-[2] card card-compact p-2 w-[16rem] mt-2 shadow-xl bg-base-200 bg-transparent-90 text-neutral-content mb-2">
                        <h3 class="card-title text-base-content text-sm mb-4">Puntos de Impacto</h3>
                        <div class="flex items-start ">
                          <div class="w-8 h-8  flex-shrink-0 absolute top-1 right-1">
                            <img src={tooltip_impact} alt="puntos" />
                          </div>
                          <div class="text-xs text-left space-y-2 text-base-content">
                            <p className="text-xs">Se acumulan (no se gastan).
Los ganas al realizar acciones, prestar o pedir prestado.
Definen tu nivel, tu posición en el ranking y los premios a los que puedes acceder.</p>
                          </div>
                        </div>
                    </div>
                    
                  </div>
                </div> 
                
              </div>
            </div>
          </div>
          <div className='px-4 -mt-8 z-10 relative'>
            <div className="flex gap-3 bg-base-content rounded-xl mb-3 shadow-lg">
              <div className='pl-3 '>
                <div className='relative'>
                <img src={medal} className='w-16' alt="medal"/>
                <p className={`absolute ${userRanking?.toString()?.length> 3?"bottom-3 text-xs":"bottom-2 text-base"}  right-0 left-0 text-center  font-bold`}>{userRanking}</p>
                </div>
              </div>
              <div className='pt-2 pr-4 pb-2 w-full'>
                <div className="w-full flex justify-between flex-col leading-4">
                  <h5 className='font-light'>
                    Ranking en
                  </h5>
                  <div className="flex justify-between items-center">
                    <h5 className="font-bold">{user.ancestors?.company?.name}</h5>
                  </div>
                </div>
                <div className='indicator'>
                  <ButtonIcon
                    buttonClassName="btn-ghost text-secondary btn-xs flex justify-between w-full p-0 tracking-wider mt-1"
                    className=""
                    onClick={()=>history.push(config.ROUTES.USER.RANKING)}
                    text={
                      <div className='flex gap-1 pr-1'>
                      {t(`Ver Ranking`)}
                      {areNewPrizes && <div className="badge badge-sm bg-error text-white border-none"></div>}
                      </div>}
                    icon='arrow_right'
                    />


                </div>
              </div>

            </div>
          </div>
          <div className="flex flex-col md:flex-col md:min-w-full text-primary-200 px-4">
            { mainMenu && mainMenu.map((item, index) => {
              let notifications = item.route === config.ROUTES.NOTIFICATIONS
              let messages = item.route === config.ROUTES.MESSAGES

              return(
                <div className="flex flex-row items-center" key={index}>
                  <MenuItem key={index} item={item} location={location} />
                  {item?.notifications && notifications && !!unReadedNotifications && <div className="badge absolute right-8 badge-sm bg-error text-white border-none">{unReadedNotifications}</div>}
                  {item?.notifications && messages && !!unReadedMessages && <div className="badge absolute right-8 badge-sm bg-error text-white border-none">{unReadedMessages}</div>}
                </div>
              )})}
          </div>
          {showingBenefits && (
            <div className="px-4 pt-5">
              <ButtonIcon
                buttonClassName="btn-secondary w-full btn-sm flex-row-reverse gap-2"
                className="w-4 h-4"
                onClick={() => history.push(config.ROUTES.MAIN.BENEFITS)}
                icon="gift"
                text={
                  <>
                    {areNewPrizes && <div className="badge badge-sm bg-error text-white border-none"></div>}
                    Ver Beneficios
                    </>
                }
              />
            </div>
          )}
        </div>

        <div className="flex flex-col md:flex-col md:min-w-full border-t text-xs font-light border-solid border-white border-opacity-20 py-2 px-3">
          {/* secondaryMenu && secondaryMenu.map((item, index) => <MenuItem key={index} item={item} location={location} />)*/}
          <ButtonIcon
              buttonClassName="text-secondary btn-ghost btn-xs flex-row-reverse gap-2"
              className="w-4 h-4"
              icon="question"
              text={capitalize(t("help"))}
              onClick={() => history.push({pathname: config.ROUTES.INFO, state: { from: location.pathname }})}
            />
        </div>

      </div>
      <div className={"fixed inset-0 z-10 w-screen h-screen bg-black bg-opacity-25 md:hidden " + (collapseShow === "open" ? "" : "hidden")}></div>

    </nav>
    { header && header.tabs &&
      <div className="px-3 flex justify-evenly items-center bg-white border-t border-base-200 gap-2">
        {header.tabs.map(t => {
          return (<a className={"px-4 py-3 w-28 text-center border-b-4 border-transparent font-medium flex-1 rounded-none " + (t.active ?  "border-b-secondary font-semibold text-base-content  " : "text-neutral" )} onClick={() => t.onClick && t.onClick()}><h5>{t.name}</h5></a>)
        })}
      </div>
    }
    </>
  );
}
